module.exports = __webpack_public_path__ + "img/1542402383.7ee8a555.jpg";